// extracted by mini-css-extract-plugin
export default {"main_div":"settingNavigation_main_div__BHS9e","header":"settingNavigation_header__zCphc","closeIcon":"settingNavigation_closeIcon__HDo0w"};